import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import SEO from '../components/seo/SEO';
import ProductGrid from '../components/products/ProductGrid';
import ProductGridSkeleton from '../components/products/ProductGridSkeleton';
import { searchProducts } from '../services/products';
import { useToast } from '../hooks/use-toast';
import { BRAND_NAME } from '../lib/brand';

const SearchPage = () => {
  const { toast } = useToast();
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const query = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('q') || '';
  }, [location.search]);

  useEffect(() => {
    const fetchResults = async () => {
      if (!query.trim()) {
        setProducts([]);
        return;
      }
      try {
        setLoading(true);
        const results = await searchProducts(query.trim());
        setProducts(results);
      } catch (error) {
        console.error('Error searching products:', error);
        toast({
          title: 'Hata',
          description: 'Arama yapılırken bir sorun oluştu.',
          variant: 'destructive',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [query, toast]);

  return (
    <Layout>
      <SEO
        title={`${BRAND_NAME} | Arama${query ? `: ${query}` : ''}`}
        description={`${BRAND_NAME} ürün arama sonuçları`}
      />
      <div className="w-full max-w-[1600px] mx-auto py-6 sm:py-8">
        <div className="mb-6 px-3 sm:px-4 md:px-6 lg:px-8">
          <h1 className="text-2xl sm:text-3xl font-bold">
            {query ? `"${query}" için sonuçlar` : 'Arama'}
          </h1>
          <p className="mt-2 text-gray-600">
            {query
              ? `${products.length} ürün bulundu`
              : 'Aramak için üst kısımdaki arama alanını kullanın.'}
          </p>
        </div>

        {loading ? (
          <ProductGridSkeleton columns={4} count={12} />
        ) : products.length > 0 ? (
          <ProductGrid products={products} columns={4} />
        ) : query ? (
          <div className="px-3 py-16 text-center text-gray-600 sm:px-4">
            Aradığınız kriterde ürün bulunamadı.
          </div>
        ) : null}
      </div>
    </Layout>
  );
};

export default SearchPage;
